import apiClient from "./ApiClient";

// Format date to SQL Server datetime format

export const getEmployeeLeaves = async (filter = {}) => {
  try {
    const response = await apiClient.post(`/api/EmployeeLeave/get`, filter);
    return response.data;
  } catch (error) {
    console.error("Error fetching employee leaves:", error);
    throw error;
  }
};

export const saveEmployeeLeave = async (leave) => {
  try {
    const response = await apiClient.post(`/api/EmployeeLeave/save`, leave);
    return response.data;
  } catch (error) {
    console.error("Error saving employee leave:", error);
    
    // Extract error message from response
    if (error.response?.status === 409) {
      const errorMessage = error.response.data?.message || error.response.data || error.message;
      throw new Error(errorMessage);
    }
    
    // For other errors, use the standard error handling
    throw error;
  }
};

export const checkBookingConflicts = async (employeeId, fromDate, toDate) => {
  try {
    console.log("🚀 API Call - checkBookingConflicts:", {
      employeeId,
      fromDate,
      toDate,
      url: `/api/EmployeeLeave/check-booking-conflicts`
    });

    const requestData = {
      EmployeeId: employeeId,
      FromDate: fromDate,
      ToDate: toDate
    };

    console.log("📤 Request data:", requestData);

    const response = await apiClient.post(`/api/EmployeeLeave/check-booking-conflicts`, requestData);
    
    console.log("📥 API Response:", response);
    console.log("📥 Response data:", response.data);
    
    return response.data;
  } catch (error) {
    console.error("❌ API Error - checkBookingConflicts:", error);
    console.error("❌ Error response:", error.response);
    console.error("❌ Error message:", error.message);
    throw error;
  }
}; 